import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 叶山小百合资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-background-50/90 text-primary-700 text-xs font-medium">
          {item.category}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <p className="text-xs text-foreground-500 mb-2 flex items-center gap-1.5">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-line text-xs"></i>
          </span>
          {item.date}
        </p>
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {item.summary}
        </p>
        <span className="mt-3 pt-3 border-t border-background-100 text-xs text-primary-600 flex items-center gap-1">
          阅读全文
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}